export type SystemRole = 'ADMIN' | 'MANAGER' | 'USER';

export const CIMT_ROLES = [
  'CIMT Leader', 'Communication', 'Operations', 'Planning',
  'Management Support', 'People & Welfare', 'Spokesperson',
  'Business Continuity', 'Finance', 'Information Technology',
  'Legal', 'Logistics', 'Site IMT Leader', 'Subject Matter Expert',
] as const;

/** A canonical CIMT role from the base list. Useful for documentation and
 *  for places that iterate over the standard 14. The DTOs accept any string
 *  though, since clients can configure custom roles on top of the base set. */
export type CimtRole = typeof CIMT_ROLES[number];

export const DAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'] as const;
export type Day = typeof DAYS[number];

export interface StaffMember {
  id: number;
  clientId: number;
  email: string;
  firstName: string;
  lastName: string;
  phone: string | null;
  jobTitle: string | null;
  systemRole: SystemRole;
  /** Either a canonical CIMT role or a per-client custom one. */
  cimtRole: string | null;
  availableDays: Day[];
  isOnLeave: boolean;
  isActive: boolean;
  inviteToken: string | null;
  inviteSentAt: string | null;
  inviteAcceptedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateStaffDTO {
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  jobTitle?: string;
  systemRole: SystemRole;
  cimtRole?: string;
  availableDays?: Day[];
}

export interface UpdateStaffDTO {
  firstName?: string;
  lastName?: string;
  phone?: string;
  jobTitle?: string;
  systemRole?: SystemRole;
  cimtRole?: string | null;
  availableDays?: Day[];
  isOnLeave?: boolean;
  isActive?: boolean;
}
